<template>
    <section class="px-3 lg:px-28 py-16 lg:py-24">
        <div class="text-center mb-10">
            <h2 class="font-semibold">Unified API or Unified MCP?</h2>
            <p class="subtitle mt-4 max-w-3xl mx-auto">
                Both run on the same connections, data models and authorization. Pick by who makes the call: your code,
                or your AI agent. Many products use both.
            </p>
        </div>

        <div class="max-w-5xl mx-auto overflow-x-auto rounded-lg border">
            <table class="w-full text-sm text-left">
                <thead class="bg-[var(--dark-gray)]">
                    <tr>
                        <th scope="col" class="p-4 w-1/5"><span class="sr-only">Compare</span></th>
                        <th scope="col" class="p-4 text-[var(--white)] text-base">Unified API</th>
                        <th scope="col" class="p-4 text-[var(--white)] text-base">Unified MCP</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in ROWS" :key="row.label" class="border-t">
                        <th scope="row" class="p-4 align-top font-semibold text-[var(--light-gray)]">{{ row.label }}</th>
                        <td class="p-4 align-top text-medium-gray">{{ row.api }}</td>
                        <td class="p-4 align-top text-medium-gray">{{ row.mcp }}</td>
                    </tr>
                    <tr class="border-t">
                        <th scope="row" class="p-4"><span class="sr-only">Learn more</span></th>
                        <td class="p-4">
                            <Button href="/technology" title="Explore the Unified API" icon="ic:round-keyboard-arrow-right"
                                variant="secondary" :full-width-mobile="false" />
                        </td>
                        <td class="p-4">
                            <Button href="/mcp" title="Explore Unified MCP" icon="ic:round-keyboard-arrow-right"
                                variant="secondary" :full-width-mobile="false" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script lang="ts">
const ROWS = [
    {
        label: 'Who calls it',
        api: 'Your application code, over REST or one of our SDKs.',
        mcp: 'An LLM or AI agent, through the Unified MCP server.',
    },
    {
        label: 'Best for',
        api: 'Customer-facing integration features, data sync into your product, and feeding embeddings or RAG pipelines.',
        mcp: 'Agents and copilots that decide at run time which data to read and which actions to take.',
    },
    {
        label: 'Reads and writes',
        api: 'Read and write unified objects (contacts, candidates, invoices…), plus passthrough for integration-specific fields.',
        mcp: 'The same reads and writes exposed as 20,000+ callable tools, so an agent can update a record or post a note.',
    },
    {
        label: 'Freshness',
        api: 'Live: every request goes to the source API. Native and virtual webhooks push changes to you.',
        mcp: 'Live: every tool call fetches from the source when the model needs it.',
    },
    {
        label: 'Authorization',
        api: 'Your customer authorizes once through Embedded Auth; you scope exactly which objects you can access.',
        mcp: 'Uses the same customer connections and scopes, so an agent can never reach beyond what was authorized.',
    },
];

export default {
    data() {
        return { ROWS };
    },
};
</script>
